// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"2d28fb65","81":"e5a3f5fc","84":"1051a9cc","113":"c88d6b99","177":"ada8f40d","601":"f84f576c","813":"762c2f8a"}[chunkId] + ".chunk.css";
};